import {
  CommonTable,
  ExpandTableContainer,
} from "components/atoms/table/AntdTable";
import { EventToHistoryPresenterProps } from "api/interfaces/subscription.interface";
import { UsagePlan } from "pages/subscription/SubscriptionStyled";
import * as s from "./EventToHistoryStyled";

export default function EventToHistoryPresenter(
  props: EventToHistoryPresenterProps
) {
  return (
    <UsagePlan.Wrapper>
      <s.Wrapper>
        <ExpandTableContainer>
          <s.TableSkin>
            <CommonTable
              rowKey="key"
              columns={props.columns}
              dataSource={props.data}
              onChangePage={props.onChangePage}
              queryInfo={props.queryInfo}
              loading={props.isFetching}
            />
          </s.TableSkin>
        </ExpandTableContainer>
      </s.Wrapper>
    </UsagePlan.Wrapper>
  );
}
